import {
  FormHelperText,
  Typography,
  FormControl,
  Input as _Input,
  InputProps,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { FC, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "../../redux/store";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Input = styled(_Input)`
  background-color: white;
  padding: 0.4rem 0.7rem;
`;

type IFormInputProps = {
  name: string;
  label: string;
} & InputProps;

const FormInput: FC<IFormInputProps> = ({ name, label, type, ...otherProps }) => {
  const darkTheme = useAppSelector((state) => state.theme.darkTheme);
  const [showPassword, setShowPassword] = useState(false);

  let bgColor = darkTheme ? "#3b3b3b" : "#efefef";

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field }) => (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500 }}
          >
            {label}
          </Typography>
          <Input
            {...field}
            type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
            fullWidth
            disableUnderline
            sx={{ borderRadius: "0.7rem", backgroundColor: bgColor }}
            error={!!errors[name]}
            {...otherProps}
            endAdornment={ type === 'password' &&
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText error={!!errors[name]}>
            {errors[name] ? (errors[name]?.message as string) : ""}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default FormInput;
